import { Component, OnInit, OnChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { ViewEncapsulation } from '@angular/core';
import { DragulaService } from 'ng2-dragula/ng2-dragula';
import { MatSlideToggle, MatTabGroup } from '@angular/material';

// import { MatSnackBar, MatSlideToggle } from '@angular/material';
import 'rxjs/add/operator/switchMap';

import * as moment from 'moment';

import { saveAs as importedSaveAs } from "file-saver";

import { Collana } from '../../../models/Collana';
import { CollanaService } from './../../../services/collana.service';
import { AppSnackbarComponent } from './../../../helpers/app-snackbar.component';
import { AppComponent } from './../../../app.component';

import { environment } from './../../../../environments/environment';

@Component({
  selector: 'app-collana-preview',
  templateUrl: './collana-preview.component.html',
  styleUrls: ['./collana-preview.component.css'],
  providers: [CollanaService],
  viewProviders: [DragulaService],
  encapsulation: ViewEncapsulation.None
})
export class CollanaPreviewComponent implements OnInit {
  collana: Collana;
  collanaCodice: string;
  loading: boolean = true;
  printing: boolean = false;
  sezioni: any[];
  publisher: string;
  sezioniMap;

  @ViewChild(MatSlideToggle) fuoricatalogo: MatSlideToggle;
  @ViewChild(MatTabGroup) xtabs: MatTabGroup;

  SEZIONE_PRINCIPALE = 'Sezione principale';

  getTitle(): string {
    return 'collana';
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private collanaService: CollanaService,
    private dragula: DragulaService,
    public parent: AppComponent) {

    this.loading = true;

    this.dragula.setOptions('bag-books', {});

    this.publisher = environment.publisher;
  }


  toggleFuoriCatalogo(e) {
    let that = this;
    this.loadCollana(this.collanaCodice, this.fuoricatalogo.checked)
  }

  apriSchedaLibro(_ean13: string) {
    this.router.navigate(['/book/' + _ean13]);
  }

  gotoSito(_ean13: string) {
    window.open(environment.urlPortale + '/control/dettagliolibro?ean13=' + _ean13, "_blank");
  }

  download() {
    console.log('============== download collana-preview.csv');
    this.parent.addToast('', 'estrazione in corso', ((wid) => {
      setTimeout(() => {
        this.collanaService.load(this.collanaCodice, this.fuoricatalogo.checked, true).subscribe(data => {
          let file = new Blob([data], { type: 'application/vnd.ms-excel' });
          importedSaveAs(file, 'elzeviro' + (moment().format('[-]YYYYMMDD[-]hhmmss')) + '.xlsx');
          this.parent.clearToast(wid);
          this.parent.operSnackBar(true, 'operazione completata');
        })
      }, 1000);
    }))
  }

  sortByDate(i: number) {
    this.sezioniMap[this.sezioni[this.xtabs.selectedIndex]].sort((a, b) => {
      return a.dtpubblicazione > b.dtpubblicazione ? i : (a.dtpubblicazione < b.dtpubblicazione ? (i * -1) : 0);
    });
  }


  print(ebook: boolean) {
    this.printing = true;
    this.parent.addToast('catalogo', 'anteprima pdf', ((wid) => {
      this.collanaService.print(this.collanaCodice, ebook).subscribe((res) => {
        this.parent.clearToast(wid);
        this.printing = false;
      })
    }).bind(this))
  }

  loadCollana(codice: string, fuoricatalogo: boolean, fc?) {

    if (codice) {
      this.loading = true;
      setTimeout(() => {
        this.collanaService.load(codice, fuoricatalogo, false)
          .subscribe(result => {
            console.log(result, result.err);
            if (result.success) {
              console.log('================== loadCollana', result)
              this.sezioniMap = result.sezioni;
              this.collana = new Collana(result.collana);
              this.collanaCodice = result.collana.codice;
              console.log('==================   this.collana', this.collana)

              this.sezioni = Object.keys(this.sezioniMap);
              console.log('==================   this.sezioniMap', this.sezioniMap)
              console.log('==================   this.sezioni', this.sezioni)
              this.sezioni = this.sezioni.sort((n1, n2) => {
                return n1 > n2 ? 1 : (n1 < n2 ? -1 : 0);
              })
            }
            if (fc) {
              fc(result)
            }
            this.loading = false;
          });
      }, 200);
    }
  }

  go2book(ean13) {
    console.log('=============== go2book', ean13);
    this.router.navigate(['/book/' + ean13]);
  }

  copied2clip(ean13) {

  }

  persist() {
    let that = this;
    that.parent.addToast('collana', 'salvataggio', ((wid) => {
      let a: any[] = [];
      that.sezioni.forEach(function(sezione, s) {
        that.sezioniMap[sezione].forEach(function(book, i) {
          a.push({
            ean13: book.ean13,
            // sezione: s > 0,
            sezione: sezione != '',
            posizione: i + 1
          })
        })
      })
      that.collanaService.sort(this.collana, a).subscribe(result => {
        that.loadCollana(
          that.collanaCodice,
          that.fuoricatalogo.checked, function() {
            that.parent.clearToast(wid);
          })
      })
    }))



  }

  sortpub(verse: number) {
    console.log(verse);
  }



  onSezioniChange(e) {
    console.log(e.value);
  }


  formatDt(dt) {
    return moment(dt).locale('it').format('DD MMM YYYY');
  }

  formatEan13(ean13) {
    //012 34 56 78901 2
    //978 88 10 12345 6
    return ean13.substring(0, 3) + '-' +
      ean13.substring(3, 5) + '-' +
      ean13.substring(5, 7) + '-' +
      ean13.substring(7, 12) + '-' +
      ean13.substring(12);
  }

  prossimaPubblicazione(dtubblicazione) {
    let wdt = moment(dtubblicazione).utc().endOf('day');
    return !moment(wdt).isBefore(moment(), "day");
  }

  isFuoriCommercio(book) {
    return !book.prezzo || book.prezzo <= 0.01;
  }

  isEsaurito(book) {
    return this.isFuoriCommercio(book) ? false : (book.statoeditore == '06' && book.statodistributore == '31');
  }

  isSenzaTitoloCollana(book) {
    // console.log('isSenzaTitoloCollana', book.ean13, book.collanaTitolo);
    return book.collanaTitolo ? false : (book.collanaSezione ? false : true);
  }

  isSenzaPrezzo(book) {
    // console.log('isSenzaPrezzo', book.ean13, book.prezzo);
    return (!book.prezzo || book.prezzo == 0);
  }

  ngOnInit() {
    this.route.paramMap
      .subscribe((params: ParamMap) => {
        console.log('======================= codice', params.get('codice'))
        this.loadCollana(params.get('codice'), false)
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/collana/collana-preview/collana-preview.component.ts